import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import * as Sentry from '@sentry/react'

import { AppRoute } from 'lib/router'
import { NotFound } from 'pages/NotFound'
import { Inboxes } from 'pages/Inboxes'

import { App } from './App'

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV6(createBrowserRouter)

export const routes = [
  {
    path: AppRoute.Root,
    element: <App />,
    children: [
      {
        path: AppRoute.Root,
        element: <Inboxes />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
]

export const Router = () => <RouterProvider router={sentryCreateBrowserRouter(routes)} />
